/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import Button from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { CloseButton } from '@atlaskit/modal-dialog';
import { type Direction, FadeIn } from '@atlaskit/motion';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { SubScreen } from './index';

const styles = cssMap({
	overlay: {
		backgroundColor: token('elevation.surface.overlay'),
		height: '100%',
		borderRadius: token('radius.medium'),
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexShrink: 0,
		paddingBlock: token('space.200'),
	},
	body: {
		paddingBlock: token('space.025'),
		paddingInline: token('space.300'),
		height: '100%',
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
	},
	content: {
		flex: '1 1 0%',
		minHeight: '0px',
	},
});

type SubScreenOverlayProps = {
	subscreen: SubScreen;
	onBack: () => void;
	onClose: () => void;
};

const enterFrom: Direction = 'left';

export const SubScreenOverlay = ({
	subscreen,
	onBack,
	onClose,
}: SubScreenOverlayProps): JSX.Element => {
	return (
		<FadeIn entranceDirection={enterFrom} exitDirection="left" duration="large">
			{(fadeInProps) => (
				<div
					{...fadeInProps}
					/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
					style={{
						...fadeInProps.style,
						position: 'absolute',
						inset: 0,
					}}
					/* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
				>
					<div css={styles.overlay}>
						<div css={styles.body}>
							<Box xcss={styles.header}>
								<Button appearance="default" iconBefore={ArrowLeftIcon} onClick={onBack}>
									{subscreen.backLabel}
								</Button>
								<CloseButton onClick={onClose} />
							</Box>
							<Box xcss={styles.content}>{subscreen.content}</Box>
						</div>
					</div>
				</div>
			)}
		</FadeIn>
	);
};
